import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseAdsExpensesComponent } from '~app/app/ads-expenses/abstract-components/base-ads-expenses.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { AdsExpensesCreationDialogComponent } from '../../modals/ads-expenses-creation-dialog/ads-expenses-creation-dialog.component';

@Component({
  selector: 'ads-expenses-datatable',
  standalone: false,
  templateUrl: './ads-expenses-datatable.component.html',
  styleUrl: './ads-expenses-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdsExpensesDatatableComponent extends BaseAdsExpensesComponent {
  private _dialogService = inject(DialogService);
  displayedColumns: string[] = ['media', 'myExpenses', 'competingExpenses'];

  dataSource = [
    {
      media: 'Télévision',
      myExpenses: 5000,
      competingExpenses: 3000
    },
    {
      media: 'Radio',
      myExpenses: 3000,
      competingExpenses: 2000
    }
  ];

  openAddDialog(): void {
    this._dialogService.open({
      component: AdsExpensesCreationDialogComponent,
      fullscreen: true
    });
  }
}
